<main class="container">
	<slot />
</main>

<style lang="postcss">
	.container {
		@apply max-w-3xl mx-auto my-5 px-5;
	}
</style>
